import React, { useState, useEffect } from 'react';
import './SignupPage.css';
import { useNavigate } from "react-router-dom";
import ToggleBtn from '../../../Components/Buttons/ToggleButton/ToggleBtn';
import { createCustomer , otpSend } from '../../../Services/CustomerService';
import Toast from '../../../Components/Toast/Toast';
import { useTranslation } from "react-i18next";
import LanguageSwitcher from '../../../Components/LanguageSwitcher/LanguageSwitcher';

const SignupPage = ({ togglePage, isLogin }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    whatsappNumber: '',
    email: '',
    password: '',
    gstNumber: '',
    company: '',
    gstVerified: null,
    hasGst: true,
    panNumber: '',
    cancelledCheque: '',
    customerAddress: '',
    street: '',
    city: '',
    state: '',
    country: '',
    zipcode: '',
    addressType: 'WORK',
    customerStatus: 'ACTIVE',
    customerTypes: 'WEAVER',
  });

  const [loading, setLoading] = useState(false);
const [toasts, setToasts] = useState([]);

   const [isVerifying, setIsVerifying] = useState(false);

  // Watch GST field and trigger API when 15 characters are entered
 useEffect(() => {
  const GST_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const validateGST = async () => {
    setIsVerifying(true);
    try {
      const response = await fetch("https://api.bulkpe.in/client/verifyGstin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer aWSVQNyt+z3IiJHV+YX9UgyVVGvsw7WKbYHBMvfjwQu8B4ZH0TDo5/foe26Zf/Qj4idKNyezUG3ux15YcAHqaKyAIyGvXVP5Wap/YcqusarvqwJO8gbXAdtntfwhjG2XJeY2cGbPzRpLV2Y5O4ZwdQ==",
        },
        body: JSON.stringify({
          gstin: formData.gstNumber,
          reference: `REF-${Date.now()}`,
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        setFormData((prev) => ({
          ...prev,
          gstVerified: true,
          company: data.data?.lgnm || "",
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          gstVerified: false,
        }));
      }
    } catch (err) {
      console.error("GST validation failed:", err);
      setFormData((prev) => ({
        ...prev,
        gstVerified: false,
      }));
    } finally {
      setIsVerifying(false);
    }
  };

  if (formData.gstNumber.length === 15) {
    if (GST_REGEX.test(formData.gstNumber.toUpperCase())) {
      validateGST();
    } else {
      setFormData((prev) => ({
        ...prev,
        gstVerified: false,
        company: "",
      }));
    }
  } else {
    setFormData((prev) => ({
      ...prev,
      gstVerified: null,
      company: "",
    }));
  }
}, [formData.gstNumber]);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  
  const handleGstCheckbox = () => {
    setFormData((prev) => ({
      ...prev,
      hasGst: !prev.hasGst,
      gstNumber: !prev.hasGst ? "" : prev.gstNumber, // optional: clear GST input if unchecked
    }));
  };

  const verifyGstNumber = async (gstNumber) => {

    const showToast = (message, type = "error") => {
            setToasts([{ message, type }]);
            setTimeout(() => setToasts([]), 3000);
          };
  try {
    const response = await fetch("https://api.bulkpe.in/client/verifyGstin", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Authorization": "Bearer aWSVQNyt+z3IiJHV+YX9UgyVVGvsw7WKbYHBMvfjwQu8B4ZH0TDo5/foe26Zf/Qj4idKNyezUG3ux15YcAHqaKyAIyGvXVP5Wap/YcqusarvqwJO8gbXAdtntfwhjG2XJeY2cGbPzRpLV2Y5O4ZwdQ==",
  },
  body: JSON.stringify({
    gstin: formData.gstNumber.trim(),
    reference: `REF-${Math.floor(Math.random() * 1000000)}`
  }),
});


    const data = await response.json();

    if (data.success) {
    setFormData((prev) => ({
      ...prev,
    gstVerified: true,
    company: data.data?.lgnm || "",
  }));
    } else {
      setFormData(prev => ({
        ...prev,
        gstVerified: false,
      }));
      showToast("Invalid GST number", "error");
    }
  } catch (error) {
    console.error("Error verifying GST:", error);
    showToast("Failed to verify GST number. Try again.", "error");
  }
};

  const handleSubmit = async (e) => {
    const showToast = (message, type = "error") => {
            setToasts([{ message, type }]);
            setTimeout(() => setToasts([]), 3000);
          };
    e.preventDefault();
    setLoading(true);

  const requiredFields = [
      formData.firstName,
      formData.lastName,
      formData.phoneNumber,
      formData.email,
      formData.password,
      // formData.gstNumber,
      formData.company,
    ];

    if (requiredFields.some((field) => !field || field.trim() === "")) {
      showToast("Please fill in all required fields.", "error");
      setLoading(false);
      return;
    }

  
    const customerData = {
      customerName: `${formData.firstName} ${formData.lastName}`.trim(),
      phoneNumber: formData.phoneNumber || null,
      whatsappNumber: formData.whatsappNumber || null,
      email: formData.email,
      password: formData.password,
      company: formData.company || null,
      gstNumber: formData.gstNumber || null,
      customerAddress: '',
      addresses: [
        {
          customerAddress: '',
          street: '',
          city: '',
          state: '',
          country: '',
          zipcode: '',
          addressType: 'HOME',
        },
      ],
      customerStatus: 'ACTIVE',
    };
  
    try {
      // Send OTPs
      if (formData.phoneNumber) {
        await otpSend({
          emailOrPhone: formData.phoneNumber,
          accountType: "CUSTOMER",
          otpType: "PHONE",
        });
      }
  
      // if (formData.email) {
      //   await otpSend({
      //     emailOrPhone: formData.email,
      //     accountType: "CUSTOMER",
      //     otpType: "EMAIL",
      //   });
      // }
  
      // Navigate to OTP page with full customer data
      navigate("/otp", {
        state: {
          customerData,  // whole object passed to OTP page
        },
      });
    } catch (error) {
      showToast(error.response.data.data.message, "error");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div
            className="w-screen h-screen bg-cover bg-center  bg-no-repeat flex items-center justify-center px-4 relative overflow-hidden">
            <div
        className="absolute inset-0 bg-center opacity-40 bg-no-repeat bg-cover filter blur-sm z-0"
        style={{
                    backgroundImage: "url('https://ik.imagekit.io/mediadata/Mo%20Ink%20n%20Dyes/dddepth-198.jpg?updatedAt=1751281331520')",
                }}
      ></div>
      {/* Logo */}
      <div className="absolute top-4 left-4 lg:left-8 lg:top-8 flex justify-center lg:justify-start w-full lg:w-auto pr-4">
        <img
          src="/images/logo.png"
          alt="Logo"
          className="w-16 sm:w-12  mx-auto lg:mx-0"
        />
      </div>

      {/* Auth Box */}
      <div className="bg-blur bg-opacity-40 p-6 sm:p-8 rounded-3xl border-3 border-white  w-full max-w-md sm:max-w-lg md:max-w-lg text-white backdrop-blur-md overflow-y-auto max-h-[90vh]">
        <h3 className="text-center text-2xl text-dark font-bold mb-4">{t("signup.welcomeTitle")}</h3>

        <div className="flex justify-center mb-12 bg-white rounded-full overflow-hidden w-full max-w-xs mx-auto">
          <button
            className="w-1/2 py-2 text-purple-700 font-medium text-l"
            onClick={togglePage}
          >
            {t("signup.login")}
          </button>
          <button className="w-1/2 py-2 bg-purple-800 text-white font-medium text-l rounded-full">
           {t("signup.register")}
          </button>
        </div>

        {/* <p className="text-center text-gray-600 text-l sm:text-l mb-6 px-2">
          Create your account to get started
        </p> */}

        <form onSubmit={handleSubmit} className="">
        <div className="flex gap-3 w-full">
        <div className="flex flex-col mb-3 basis-1/2">
          {/* <label className="block text-dark text-l font-semibold mb-1">First Name</label> */}
          <input
            className="login-input rounded-full text-black placeholder-gray-500 border-1 border-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 px-4 py-1 w-full"
            placeholder={t("signup.firstName")}
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="flex flex-col basis-1/2">
          {/* <label className="block text-dark text-l font-semibold mb-1">Last Name</label> */}
          <input
            className="login-input rounded-full text-black placeholder-gray-500 border-1 border-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 px-4 py-1 w-full"
            placeholder={t("signup.lastName")}
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />
        </div>
      </div>


          <div className="flex flex-col sm:flex-row sm:gap-4 md:gap-4 w-full">
          <div className="flex flex-col w-full sm:w-1/2 mb-3">
            <input
              className="login-input rounded-full text-black placeholder-gray-500 border-1 border-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 px-4 py-1 w-full"
              placeholder={t("signup.email")}
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex flex-col w-full sm:w-1/2 relative mb-3">
            <input
              className="login-input rounded-full text-black placeholder-gray-500 border-1 border-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 px-4 py-1 w-full pr-10"
              placeholder={t("signup.gstNumber")}
              name="gstNumber"
              value={formData.gstNumber}
              onChange={handleChange}
              disabled={!formData.hasGst}
              maxLength={15}
            />
            {formData.gstNumber.length === 15 && (
              <span className="absolute right-3 top-1 text-lg">
                {isVerifying ? (
                  <span className="text-center text-yellow-500">⏳</span>
                ) : formData.gstVerified ? (
                  <span className="text-center text-green-600">✔️</span>
                ) : (
                  <span className="text-center text-red-500">❌</span>
                )}
              </span>
            )}
          </div>
        </div>

          <div className="flex gap-3 w-full mb-3">
        <div className="flex flex-col basis-1/2">
            {/* <label className="block text-dark text-l font-semibold mb-1">Phone</label> */}
            <input
              className="login-input rounded-full text-black placeholder-gray-500 border-1 border-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 px-4 py-1 w-full"
              placeholder={t("signup.phoneNumber")}
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
            />
          </div>

          <div className="flex flex-col basis-1/2">
            {/* <label className="block text-dark text-l font-semibold mb-1">WhatsApp</label> */}
            <input
              className="login-input rounded-full  px-4 py-1 w-full text-black placeholder-gray-500 border-1 border-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 placeholder-gray-500 border-1 border-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder={t("signup.whatsappNumber")}
              name="whatsappNumber"
              value={formData.whatsappNumber}
              onChange={handleChange}
            />
          </div>
        </div>

           <div className="flex gap-3 w-full mb-3">
        <div className="flex flex-col basis-1/2">
              {/* <label className="block text-dark text-l font-semibold mb-1">Password</label> */}
              <input
                type="password"
              className="login-input rounded-full text-black placeholder-gray-500 border-1 border-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 px-4 py-1 w-full"
                placeholder={t("signup.password")}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

          {/* Company Field */}
          <div className="flex flex-col basis-1/2">
            {/* <label className="block text-dark text-l font-semibold mb-1">Company</label> */}
            <input
              className="login-input rounded-full text-black placeholder-gray-500 border-1 border-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 px-4 py-1 w-full"
              placeholder={t("signup.company")}
              name="company"
              value={formData.company}
              onChange={handleChange}
            />
          </div>
        </div>



              <div className="flex flex-row justify-between items-center text-sm text-gray-600 mb-3">
                    <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={!formData.hasGst}
                      onChange={handleGstCheckbox}
                    />
                    {t("signup.noGst")}
                  </label>
                    
            </div>
          
          <button
                        type="submit"

                        className="w-full bg-purple-800 text-white rounded-full py-2 font-medium"
                        onClick={() => handleSubmit }

                    >
                        {t("signup.getOtp")}
                    </button>
        </form>
       
      </div>

       {/* <div className="mt-3 d-flex justify-center position-absolute top-2 right-5">
                <div>
              <LanguageSwitcher className="w-full" />
                </div>
        </div> */}
       {/* Toast Notification */}
     <div className="fixed top-4 right-4 z-50 space-y-2">
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        message={toast.message}
                        type={toast.type}
                        onClose={() =>
                            setToasts((prev) => prev.filter((t) => t.id !== toast.id))
                        }
                    />
                ))}
            </div>
             

    </div>
  );
};

export default SignupPage;
